module.exports = __webpack_public_path__ + "static/media/umojalogo.f8ed45ba.png";